import React from "react";

export function AgendaArchive() {
    return (
<>
        <center>
		<br/>
            <br/>
            <br/>
            <br/>
            <br/>
			<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2
">
<u><center><strong>2026 Agendas</strong></center></u>
</td>
</tr>
<tr>
<td valign="top"></td>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2026/FD%231+Agenda+(11).docx" target="new">November 2026</a><br/>

<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2026/FD%231+Agenda+(10).docx" target="new">October 2026</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2026/FD%231+Agenda_Sept26.docx" target="new">September 2026</a><br/>
				<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2026/FD%231+Agenda+(9).docx" target="new">August 2026</a><br/>	

				<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2026/FD%231+Agenda+(7).docx" target="new">July 2026</a><br/>	

				<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2026/FD%231+Agenda+(6).docx" target="new">June 2026</a><br/>	

				<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2026/FD%231+Agenda+(5).docx" target="new">May 2026</a><br/>	

				<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2026/FD%231+Agenda+(3).docx" target="new">April 2026</a><br/>	

				<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2026/FD%231+Reorg+Agenda.docx" target="new">March 2026</a><br/>	

				<a href="https://diuy0t6boke2n.cloudfront.net/FD%231+Agenda+(2).docx" target="new">February 2026</a><br/>	
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2025/agendaJan2025.docx" target="new">January 2026</a><br/>

</tr>
</tbody>
</table>

	<table width="auto" border="3">
<tbody><tr>
<td colspan="2
">
<u><center><strong>2025 Agendas</strong></center></u>
</td>
</tr>
<tr>
<td valign="top">

<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2025/FD%231+Agenda+(1).docx" target="new">January 2025</a><br/>

<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2025/FD%231ReorgAgenda.docx" target="new">March 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2025/FD%231+Agenda+april.docx" target="new">April 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/FD%231+Agenda+(1).docx" target="new">May 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2025/FD%231+Agenda+June.docx" target="new">June 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/FD%231+Agenda+(3).docx" target="new">July 2025</a><br/></td>
	<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2025/FD%231+Agenda+(4).docx" target="new">August 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2025/FD%231+Agenda.docx" target="new">September 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2025/FD%231+Agenda+(1).docx" target="new">October 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2025/November+2025+Agenda.docx" target="new">November 2025</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/FD%231+Agenda.docx" target="new">December 2025</a><br/>






	   	</td>
<td valign="top">

	</td>
</tr>
</tbody>
</table>
	<table width="auto" border="3">
<tbody><tr>
<td colspan="2
">
<u><center>


<strong>2024 Agendas</strong>
</center></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2024/agendaJan2024.docx" target="new">January 10, 2024</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2024/agendaFeb2024.docx" target="new">February 14, 2024</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2024/agendaMar2024.docx" target="new">March 13, 2024</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2024/agendaApril2024.docx" target="new">April 10, 2024</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2024/agendaMay2024.docx" target="new">May 8, 2024</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2024/agendaJune2024.docx" target="new">June 12, 2024</a></td>
	<td valign="top">
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2024/agendaJuly2024.docx" target="new">July 10, 2024</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2024/agendaAug2024.docx" target="new">August 14, 2024</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2024/agendaSept2024.docx" target="new">September 11, 2024</a>
	</td>
</tr>
</tbody>
</table>
	<p>&nbsp;</p>
	<table width="auto" border="3">
<tbody><tr>
<td colspan="2
">
<u><center><strong>2023 Agendas</strong></center></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2023/agendaJan2023.doc" target="new">January 11, 2023</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2023/agendaFeb2023.doc" target="new">February 8, 2023</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2023/agendaMarch2023.docx" target="new">March 8, 2023</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2023/agendaApril2023.docx" target="new">April 12, 2023</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2023/agendaMay2023.docx" target="new">May 10, 2023</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2023/agendaJune2023.docx" target="new">June 14, 2023</a>
	   	</td>
<td valign="top">
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2023/agendaJuly2023.docx" target="new">July 12, 2023</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2023/agendaAug2023.docx" target="new">August 9, 2023</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2023/agendaSept2023.docx" target="new">September 13, 2023</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2023/agendaOct2023.docx" target="new">October 18, 2023</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2023/agendaNov2023.docx" target="new">November 8, 2023</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2023/agendaDec2023.docx" target="new">December 13, 2023</a>
	</td>
</tr>
</tbody>
</table>
	<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2
">
<u><center><strong>2022 Agendas</strong></center></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2022/agendaJan2022.doc" target="new">January 12, 2022</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2022/agendaFeb2022.doc" target="new">February 9, 2022</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2022/agendaMarch2022.doc" target="new">March 9, 2022</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2022/agendaApril2022.doc" target="new">April 13, 2022</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2022/agendaMay2022.doc" target="new">May 11, 2022</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2022/agendaJune2022.doc" target="new">June 8, 2022</a>
	</td>
	<td valign="top">
		<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2022/agendaJuly2022.doc" target="new">July 13, 2022</a><br/>
			<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2022/agendaAug2022.pdf" target="new">August 10, 2022</a><br/>
			<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2022/agendaSept2022.pdf" target="new">September 14, 2022</a><br/>
			<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2022/agendaOct2022.doc" target="new">October 12, 2022</a><br/>
			<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2022/agendaNov2022.doc" target="new">November 9, 2022</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2022/agendaDec2022.doc" target="new">December 14, 2022</a>
		  </td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2
">
<u><center><strong>2021 Agendas</strong></center></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2021/agendaJan2021.doc" target="new">January 13, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2021/agendaFeb2021.doc" target="new">February 10, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2021/agendaMarch2021.doc" target="new">March 10, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2021/agendaApril2021.doc" target="new">April 14, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2021/agendaMay2021.doc" target="new">May 12, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2021/agendaJune2021.doc" target="new">June 9, 2021</a>
</td>
<td valign="top">
<p><a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2021/agendaJuly2021.doc" target="new">July 14, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2021/agendaAug2021.doc" target="new">August 11, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2021/agendaSept2021.doc" target="new">September 8, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2021/agendaOct2021.doc" target="new">October 20, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2021/agendaNov2021.doc" target="new">November 10, 2021</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2021/agendaDec2021.doc" target="new">December 8, 2021</a>
</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2
">
<u><center><strong>2020 Agendas</strong></center></u>
</td>
</tr>
<tr>
<td width="144" valign="top">
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2020/agendaJan2020.pdf" target="new">January 8, 2020</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2020/agendaFeb2020.pdf" target="new">Febr//uary 12, 2020</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2020/AgendaMarch2020.doc" target="new">March 11, 2020</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2020/AgendaApril2020.doc" target="new">April 8, 2020</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2020/agendaMay2020.pdf" target="new">May 13, 2020</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2020/agendaJune2020.pdf" target="new">June 10, 2020</a>
</td>
<td width="144" valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2020/agendaJuly2020.pdf" target="new">July 8, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2020/agendaAugust2020.pdf" target="new">August 12, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2020/AgendaSept2020.doc" target="new">September 9, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2020/AgendaOct2020.doc" target="new">October 9, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2020/agendaNov2020.pdf" target="new">November 11, 2020</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2020/agendaDec2020.pdf" target="new">December 9, 2020</a>
</td>
	</tr>
	</tbody></table>
	<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2
">
<u><center><strong>2019 Agendas</strong></center></u>
</td>
</tr>
<tr>
<td width="144" valign="top">
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2019/agendaJan19.doc" target="new">January 9, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2019/agendaFeb19.doc" target="new">February 13, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2019/agendaMar19.doc" target="new">March 13, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agenda/2019/agendaApr19.pdf" target="new">April 10, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agenda/2019/agendaMay19.doc" target="new">May 8, 2019</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agenda/2019/agendaJune19.doc" target="new">June 12, 2019</a><br/>
	</td>
	<td width="125" valign="top">
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2019/agendaJuly19.pdf" target="new">July 10, 2019</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2019/agendaAug19.pdf" target="new">August 14, 2019</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2019/agendaSept19.doc" target="new">September 11, 2019</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2019/agendaOct19.doc" target="new">October 9, 2019</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2019/agendaNov19.doc" target="new">November 13, 2019</a><br/>
		<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2019/agendaDec19.doc" target="new">December 11, 2019</a>
	</td>
	</tr>
	</tbody></table>
	<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2
">
<u><center><strong>2018 Agendas</strong></center></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2018/AGENDAJAN18.doc" target="new">January 10, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2018/agendafeb18.doc" target="new">February 14, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2018/AGENDAmarch18.doc" target="new">March 14, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2018/agendaAPR18.doc" target="new">April 11, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2018/agendaMAY18.doc" target="new">May 9, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2018/AgendaJune18.doc" target="new">June 13, 2018</a>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2018/agendaJULY18.doc" target="new">July 11, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2018/agendaAUG18.doc" target="new">August 8, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2018/AgendaSept18.doc" target="new">September 12, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2018/AgendaOct18.pdf" target="new">October 10, 2018</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2018/AgendaNov18.doc" target="new">November 14, 2018</a><br/>
	<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2018/agendaDec18.doc" target="new">December 12, 2018</a>
</td>
</tr>
</tbody></table>
<p>&nbsp;</p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><center><strong>2017 Agendas</strong></center></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2017/AGENDAJAN17.doc" target="new">January 11, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2017/agendafeb17.doc" target="new">February 8, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2017/AGENDAmarch17.doc" target="new">March 8, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2017/agendaAPR17.doc" target="new">April 12, 2017</a><br/>   
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2017/agendaJUNE17doc.doc" target="new">June 14, 2017</a><br/>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2017/agendaJULY17.doc" target="new">July 12, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2017/agendaAug2017.doc" target="new">August 9, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2017/agendaSEPT17doc.doc" target="new">September 13, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2017/agendaOCT17doc.doc" target="new">October 11, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2017/agendaNOV17.doc" target="new">November 8, 2017</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2017/agendaDEC17doc.doc" target="new">December 13, 2017</a>
</td>
</tr>
</tbody></table>
<p></p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><center><strong>2016 Agendas</strong></center></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2016/AGENDAJAN16.doc" target="new">January 13, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2016/agendafeb16.doc" target="new">February 10, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2016/AGENDAmarch16.doc" target="new">March 9, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2016/agendaAPR16.doc" target="new">April 13, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2016/agendaMAY16.doc" target="new">May 11, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2016/agendaJUNE16.doc" target="new">June 8, 2016</a>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2016/agendaJULY16.doc" target="new">July 13, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2016/agendaAug2016.doc" target="new">August 10, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2016/agendaSEPT16.doc" target="new">September 14, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2016/agendaOCT16doc.doc" target="new">October 12, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2016/agendaNOV16.doc" target="new">November 9, 2016</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2016/agendaDEC16.doc" target="new">December 14, 2016</a>
</td>
</tr>
</tbody></table>
<p>&nbsp;</p>
<p></p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><center><strong>2015 Agendas</strong></center></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2015/agendaJAN15.doc" target="new">January 21, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2015/agendafeb15.doc" target="new">February 18, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2015/AGENDAmarch15.doc" target="new">March 18, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2015/agendaAPR15.doc" target="new">April 15, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2015/agendaMAY15.doc" target="new">May 20, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2015/agendaJUNE15.doc" target="new">June 17, 2015</a>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2015/agendaJULY15.doc" target="new">July 15, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2015/agendaAug2015.doc" target="new">August 19, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2015/agendaSEPT15.doc" target="new">September 16, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2015/agendaOCT15.doc" target="new">October 21, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2015/agendaNOV15.doc" target="new">November 18, 2015</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2015/agendaDEC15.doc" target="new">December 16, 2015</a>
</td>
</tr>
</tbody></table>
<p></p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><center><strong>2014 Agendas</strong></center></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2014/AGENDAJAN14.doc" target="new">January 15, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2014/agendafeb14.doc" target="new">February 19, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2014/AGENDAmarch14.doc" target="new">March 14, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2014/agendaAPR14.doc" target="new">April 16, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2014/agendaMAY14.doc" target="new">May 21, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2014/agendaJUNE14.doc" target="new">June 18, 2014</a>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2014/agendaJULY14.doc" target="new">July 16, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2014/agendaAUG14.doc" target="new">August 20, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2014/agendaSEPT14.doc" target="new">September 17, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2014/agendaOCT14.doc" target="new">October 15, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2014/agendaNOV14.doc" target="new">November 19, 2014</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2014/agendaDEC14.doc" target="new">December 17, 2014</a>
</td>
</tr>
</tbody></table>
<p></p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><center><strong>2013 Agendas</strong></center></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2013/AGENDAJAN13.doc" target="new">January 16, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2013/agendafeb13.doc" target="new">February 20, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2013/AGENDAmarch13.doc" target="new">March 20, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2013/agendaAPR13.doc" target="new">April 17, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2013/agendaMAY13.doc" target="new">May 15, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2013/agendaJUNE13.doc" target="new">June 19, 2013</a><br/>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2013/agendaJULY13.doc" target="new">July 17, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2013/agendaAUG13.doc" target="new">August 21, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2013/agendaSEPT13.doc" target="new">September 18, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2013/agendaOCT13.doc" target="new">October 16, 2013</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2013/agendaDEC13.doc" target="new">December 18, 2013</a>
</td>
</tr>
</tbody></table>
<p></p>
<table width="auto" border="3">
<tbody><tr>
<td colspan="2">
<u><center><strong>2012 Agendas</strong></center></u>
</td>
</tr>
<tr>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2012/AGENDAJAN12.doc" target="new">January 18, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2012/agendafeb12.doc" target="new">February 15, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2012/AGENDAmarch12.doc" target="new">March 21, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2012/agendaAPR12.doc" target="new">April 18, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2012/agendaMAY12.doc" target="new">May 16, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2012/agendaJUNE12.doc" target="new">June 20, 2012</a><br/>
</td>
<td valign="top">
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2012/agendaJULY12.doc" target="new">July 18, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2012/agendaAUG12.doc" target="new">August 15, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2012/agendaSEPT12.doc" target="new">September 19, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2012/agendaOct12.doc" target="new">October 17, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2012/agendaNOV12.doc" target="new">November 21, 2012</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2012/agendaDEC12.doc" target="new">December 19, 2012</a>
</td>
</tr>
</tbody></table>
<p></p>
<table width="auto" border="3">
<tbody><tr>
<td>
<center><u><strong>2011 Agendas</strong></u></center>
</td>
</tr>
<tr>
<td>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2011/07202011agenda.doc" target="new">July 20, 2011</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2011/08172011agenda.doc" target="new">August 17, 2011</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2011/agendaSEPT2011.doc" target="new">September 21, 2011</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2011/agendaOCT2011.doc" target="new">October 19, 2011</a><br/>
<a href="https://diuy0t6boke2n.cloudfront.net/Agendas/2011/agendaNOV2011.doc" target="new">November 16, 2011</a>
</td>
</tr>
</tbody></table>

</center>
        </>
    )
}